function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(250, 250, 250)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'olive-slate': 'rgb(87, 112, 52)','storm-grey': 'rgb(181, 186, 184)','rose-gold': 'rgb(211, 125, 131)','fox-orange': 'rgb(210, 114, 33)','lunar-yellow': 'rgb(217, 174, 35)','sunlit-grove': 'rgb(217, 174, 35)','sahara-blue': 'rgb(25, 58, 68)','black-wool': 'rgb(38, 38, 38)','forest-green': 'rgb(26, 79, 53)','london-red': 'rgb(155, 2, 2)','coral-coastline': 'rgb(229, 138, 76)','inkstone': 'rgb(0, 100, 128)','aspen-gold': 'rgb(217, 174, 35)','amethyst': 'rgb(42, 17, 63)','desert-sky': 'rgb(182, 107, 62)','ocean-blue': 'rgb(19, 100, 224)','hunter-green': 'rgb(79, 126, 94)','imperial-ruby': 'rgb(227, 7, 62)','royal-plum': 'rgb(101, 65, 97)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
